import { CommonModule, DatePipe, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApplyAdComponent } from '../../../components/apply-ad/apply-ad';
import { FeatureSkillsComponent } from '../../../components/feature-skills/feature-skills';
import { FooterComponent } from '../../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../../components/header-desktop/header-desktop';
import { ImageGalleryComponent } from '../../../components/image-gallery/image-gallery';
import { SlugifyPipe } from '../../../components/slugify.pipe';
import { TypePipe } from '../../../components/type.pipe';
import { YoutubePlayerComponent } from '../../../components/youtube-player/youtube-player';
import { AuthService } from '../../../core/auth.service';
import { AdService } from '../../../core/ad.service';
import { globals } from '../../../../environments/globals';
import { environment } from '../../../../environments/environment';

@Component({
    imports: [CommonModule, ApplyAdComponent, FeatureSkillsComponent, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent, ImageGalleryComponent, SlugifyPipe, TypePipe, YoutubePlayerComponent],
    selector: 'app-detail',
    styleUrls: ['./detail.page.scss'],
    templateUrl: './detail.page.html'
})
export class DetailPage implements OnInit {
  bucketURL: string = environment.firebase.bucketURL;
  slug: any;
  url: string = '';
  link: string = '';
  ad: any;
  directory: any = globals.directory;
  directory_data: any;
  isApply: boolean = false;
  text: any;
  constructor(
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private as: AdService,
    public auth: AuthService, 
    // private iab: InAppBrowser,
    // private platform: Platform,
    private metaService: Meta,
    private route: ActivatedRoute,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.slug = this.route.snapshot.paramMap.get('slug');
    this.as.adDetails(this.slug).subscribe(data => {
      this.ad = data[0];
      if(this.ad.country) {
        this.directory_data = this.directory[this.ad.country];
        this.titleService.setTitle(this.ad.title + ' | ' + (this.ad.location=='remote' ? 'Remote' : 'Onsite ' + this.ad.suburb + ' ' + this.ad.city) + ' ' + this.directory_data.name);
        this.metaService.updateTag(
          { name: 'description', property: 'og:description', content: this.ad.title + ' | ' + (this.ad.location=='remote' ? 'Remote - Work from Anywhere' : 'Onsite ' + this.ad.suburb + ' ' + this.ad.city) + ' ' + this.directory_data.name + ' | ' + this.ad.overview }
        )
        this.createStructuredData();
      }
      if(this.ad.url) {
        if (this.ad.url.startsWith('http://') || this.ad.url.startsWith('https://')) {
          this.url = this.ad.url;
          this.link = this.url.split('//')[1];
        } else {
          this.url = 'https://' + this.ad.url;
          this.link = this.ad.url;
        }
      }
      if(this.ad.video) {
        this.videoStructuredData();
      }
    })
  }

  createStructuredData() {
    if (isPlatformBrowser(this.platformId)) {
      const script = <HTMLScriptElement> this.doc.head.querySelector("script[type='application/ld+json']")
      || this.doc.head.appendChild(this.doc.createElement("script"));
      if(this.ad) {
        this.text = {
          "@context": "https://schema.org",
          "@type" : "LocalBusiness",
          "name" : this.ad.title,
        }
        if(this.ad.location == 'onsite') {
          this.text.address = {
            "@type": "Place",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": this.ad.suburb,
              "addressLocality": this.ad.city,
              "addressRegion": this.ad.region,
              "addressCountry": this.ad.country
            }
          }
        }
        if(this.ad.url && this.ad.url.length > 0) {
          if (!this.ad.url.startsWith('http://') && !this.ad.url.startsWith('https://')) {
            this.ad.url = 'https://' + this.ad.url;
          }
          let url = new URL(this.ad.url);
          this.text.url = url.host;
        }
        if(this.ad.phone && this.ad.phone.length > 0) {
          this.text.telephone = this.ad.phone;
        }
        if(this.ad.logo && this.ad.logo.length > 0) {
          this.text.image = [this.bucketURL + this.ad.logo + '?alt=media'];
        }
      }

      script.type = "application/ld+json";
      script.text = JSON.stringify(this.text);
    }
  }

  videoStructuredData() {
    if (isPlatformBrowser(this.platformId)) {
      const script = <HTMLScriptElement> this.doc.body.querySelector("script[type='application/ld+json']")
      || this.doc.body.appendChild(this.doc.createElement("script"));
      if(this.ad) {
        this.text = {
          "@context": "https://schema.org",
          "@type" : "VideoObject",
          "name" : this.ad.title,
          "description" : this.ad.overview,
          "uploadDate" : this.ad.posted,
          "embedUrl" : this.ad.video
        }
      }
      if(this.ad.video && this.ad.video !== '') {
        this.text.thumbnailUrl = ["https://i.ytimg.com/vi_webp/" + this.ad.video.slice(-11) + "/maxresdefault.webp"];
      }

      script.type = "application/ld+json";
      script.text = JSON.stringify(this.text);
    }
  }

  openExternalLink(url: string) {
    // if (this.platform.is('cordova')) {
    //   this.iab.create(url, '_system');
    // } else {
      window.location.href = url;
    // }
  }
}